import React, { Fragment, useState } from "react";
import { Table } from "../../../../components/Table/Table";
import { useOnlineInvoice } from "../../../../hooks/useCrm";
import { OnlineInvoiceStyle } from "./OnlineInvoiceStyle";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { AiFillEdit, AiFillTag } from "react-icons/ai";
import { BsFillPersonCheckFill } from "react-icons/bs";
import Typogaphy from "../../../../components/Typography/Typography";
import Button from "../../../../components/Button/Button";
import { ResponsibleChangeOnlineInvoiceModal } from "../../../../components/Dialog/ResponsibleChangeOnlineInvoiceModal";
import { TagSelectionOnlineInvoiceModal } from "../../../../components/Dialog/TagSelectionOnlineInvoiceModal";
import Converter from "persian-date-converter";
import { EditOnlineInvoiceModal } from "../../../../components/Dialog/EditOnlineInvoiceModal";

const initvalue = {
  TagSelectionOnlineInvoice: false,
  ResponsibleChangeOnlineInvoice: false,
  EditInvoice: false,
};
export const OnlineInvoice = ({ userdata, tags }) => {
  const [show, setShow] = useState(initvalue);
  const [factor, setFactor] = useState();
  const [factorId, setFactorId] = useState();
  const [factorTag, setFactorTag] = useState();
  const [factorResponsible, setFactorResponsible] = useState();
  const id = userdata?.sales_opportunities[0].IdUser;
  const { data: OnlineInvoice, isloading: OnlineInvoiceLoading } =
    useOnlineInvoice({ IdUserFile: id });
  const _date = new Converter();
  const Factors = OnlineInvoice?.data;
  const listMarket = Factors?.MarketerUser?.map((market) => market);

  return (
    <OnlineInvoiceStyle>
      {Factors?.order_onlines?.map((factor, index) => {
        const color = tags?.filter((tag) =>
          tag?.NameTag === factor?.FactorTag ? tag?.ColorTag : ""
        );
        const createDate = factor.created_at;
        var dateWrapper = _date.convert(createDate, "fa");
        return (
          <div className="invoice row" key={index}>
            <div className="status col-lg-1 col-md-1 col-1 p-0">
              <IoCheckmarkDoneOutline
                className="icon"
                color={color[0]?.ColorTag}
              />
            </div>
            <div className="main-content col-lg-5 col-md-6 col-8">
              {/* <Typogaphy size="14px">{name + " " + lastname}</Typogaphy> */}
              <Typogaphy size="14px">
                مسئول:
                {Factors?.MarketerUser.map((item, index) => (
                  <Fragment key={index}>
                    {item.IdOrderOnline === factor.IdOrderOnline
                      ? item.FirstName + " " + item.LastName
                      : null}
                  </Fragment>
                ))}
              </Typogaphy>
              <Typogaphy size="14px">تاریخ: {dateWrapper}</Typogaphy>
              <Typogaphy size="14px">
                ثبت شده توسط:{" "}
                {factor?.FirstName && factor?.LastName
                  ? factor.FirstName + " " + factor.LastName
                  : userdata?.sales_opportunities[0].FirstName +
                    " " +
                    userdata?.sales_opportunities[0].LastName}
              </Typogaphy>
            </div>
            <div className="price col-lg-2 col-md-5 col-3">
              <Typogaphy>{factor.DepositAll.toLocaleString()} تومان</Typogaphy>
            </div>
            <div className="actions col-lg-4 col-md-12 justify-content-center mt-lg-0 mt-3 justify-content-lg-left justify">
              <Button
                onclick={() => {
                  setShow({ ...show, ResponsibleChangeOnlineInvoice: true });
                  setFactorId(factor.IdOrderOnline);
                  setFactorResponsible(
                    listMarket[index]?.FirstName +
                      " " +
                      listMarket[index]?.LastName
                  );
                }}
                bgColor="#009ef7"
              >
                <BsFillPersonCheckFill color="#fff" className="mx-auto" />
              </Button>
              <Button
                onclick={() => {
                  setShow({ ...show, TagSelectionOnlineInvoice: true });
                  setFactorId(factor.IdOrderOnline);
                  setFactorTag(factor.FactorTag);
                }}
                bgColor="#50cd89"
              >
                <AiFillTag color="#fff" className="mx-auto" />
              </Button>
              <Button
                onclick={() => {
                  setShow({ ...show, EditInvoice: true });
                  setFactor(factor);
                }}
                bgColor="#f1416c"
              >
                <AiFillEdit color="#fff" className="mx-auto" />
              </Button>
            </div>
          </div>
        );
      })}
      <ResponsibleChangeOnlineInvoiceModal
        handleClose={() =>
          setShow({ ...show, ResponsibleChangeOnlineInvoice: false })
        }
        show={show.ResponsibleChangeOnlineInvoice}
        factorId={factorId}
        factorResponsible={factorResponsible}
      />
      <TagSelectionOnlineInvoiceModal
        handleClose={() =>
          setShow({ ...show, TagSelectionOnlineInvoice: false })
        }
        show={show.TagSelectionOnlineInvoice}
        factorId={factorId}
        factorTag={factorTag}
      />
      <EditOnlineInvoiceModal
        handleClose={() => setShow({ ...show, EditInvoice: false })}
        show={show.EditInvoice}
        factor={factor}
      />
    </OnlineInvoiceStyle>
  );
};
